import { inject } from '@angular/core';
import { GvTaTrackerAssignmentApiService } from '@shared/services';
import { PopoverHandlerConfig, PopoverConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { assignGvTaTrackerFormConfig } from '@shared/components/edit-create-form';

export const assignGvTaTrackerPopoverConfig = (
    onSuccess: () => void,
    onCancel: () => void
): PopoverConfig => {
    const trackerAssignmentApiService = inject(GvTaTrackerAssignmentApiService);

    return {
        width: '600px',
        title: 'Phân công Tracker cho GV/TA',
        dismissable: true,
        styleClass: 'p-fluid',
        formConfig: assignGvTaTrackerFormConfig(),
        actions: [defaultCancelAction, defaultConfirmAction],
        handlerConfig: {
            service: trackerAssignmentApiService,
            method: 'assignGvTaToTracker',
            entityLabel: 'phân công tracker',
            commonDataTransform: (formValue: any) => {
                const data: any = {
                    gvTaEmployeePositionId: formValue.gvTaEmployeePositionId,
                    trackerEmployeePositionId: formValue.trackerEmployeePositionId,
                    fromDate: formValue.fromDate
                };
                if (formValue.toDate) {
                    data.toDate = formValue.toDate;
                }
                return data;
            },
            initialDataTransform: (rawData: any) => ({
                gvTaEmployeePositionId: rawData.gvTaEmployeePositionId || null,
                trackerEmployeePositionId: rawData.trackerEmployeePositionId || null,
                fromDate: rawData.fromDate || new Date(new Date().setHours(0, 0, 0, 0)),
                toDate: rawData.toDate || null
            }),
            onSuccess,
            onCancel
        } as PopoverHandlerConfig
    };
};

